<template>
	<div class="vx-row">
		<div class="vx-col w-full flex items-center">
			<vs-prompt
				class="export-options"
				type="alert"
				:title="$t('UploadFiles.Download') + ' ' + this.textTitle"
				:accept-text="$t('UploadFiles.Download')"
				:active.sync="showDownload"
				:is-valid="isActiveDownload"
				@accept="exportList"
				@close="clearFields"
				@cancel="clearFields"
			>
				<vx-card :cardBorder="true" :noShadow="true">
					<div class="vx-row">
						<div class="w-full mb-2">
							<small class="date-label">{{ $t("Routing.Title.SelectFormat") }}</small>
							<v-select
								class="w-full"
								v-model="formatSelect"
								value="value"
								label="text"
								:placeholder="$t('Select')"
								:clearable="false"
								:options="formatOptions"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
							>
								<template v-slot:no-options="{search, searching}">
									<template v-if="searching">
										{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
									</template>
									<template v-else>
										{{ $t("NoResultsFound") }}
									</template>
								</template>
							</v-select>
						</div>
					</div>
				</vx-card>
			</vs-prompt>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import {saveAs} from "file-saver";
export default {
	props: {
		dataToDownload: {
			type: Array,
			required: true,
			default: () => [],
		},
		activeDownload: {
			type: Boolean,
			default: () => false,
		},
		textTitle: {
			type: String,
			default: "",
		},
		fieldsOptimization: {
			type: String,
			default: "",
		},
	},
	components: {
		vSelect,
	},
	data() {
		return {
			formatSelect: {text: "XLSX", value: "xlsx"},
			formatOptions: [
				{text: "XLSX", value: "xlsx"},
				{text: "CSV", value: "csv"},
				{text: "TXT", value: "txt"},
				{text: "JSON", value: "json"},
			],
		};
	},
	computed: {
		isActiveDownload() {
			return this.formatSelect !== null && this.formatSelect !== undefined && this.formatSelect !== "";
		},
		showDownload: {
			get() {
				return this.activeDownload;
			},
			set(val) {
				this.$emit("activePopupEmit", val);
			},
		},
	},
	methods: {
		clearFields() {
			this.formatSelect = {text: "XLSX", value: "xlsx"};
			this.showDownload = false;
		},
		async downloadFileFromFirebase(fileRef, filename) {
			try {
				const url = await fileRef.getDownloadURL();
				const response = await fetch(url);
				const blob = await response.blob();
				saveAs(blob, filename);
				this.$vs.notify({
					color: "success",
					title: this.$t("Success"),
					text: this.$t("Routing.Map.ExportRoute.Success"),
				});
			} catch (error) {
				console.error("Error en la descarga:", error);
				this.$vs.notify({
					color: "danger",
					title: this.$t("Error"),
					text: this.$t("Routing.Map.ExportRoute.Error"),
				});
			}
		},
		exportList() {
			const payload = {
				[this.fieldsOptimization]: this.dataToDownload,
				file_type: this.formatSelect.value || "xlsx",
			};
			this.$vs.loading({
				container: "#optimization-download-content",
				scale: 0.6,
				text: this.$t("Routing.Buttons.Downloading"),
			});
			this.$store
				.dispatch("moduleOptimization/generateDownloadOptimization", payload)
				.then((res) => {
					console.clear();
					const fileRef = this.$storage.ref().child(res.data.url);
					let filename = res.data.filename;
					this.downloadFileFromFirebase(fileRef, filename);
					this.formatSelect = {text: "XLSX", value: "xlsx"};
					this.showDownload = false;
					this.$vs.loading.close("#optimization-download-content > .con-vs-loading");
					this.$vs.notify({
						color: "success",
						title: this.$t("Success"),
						text: this.$t("Routing.Map.ExportRoute.Success"),
					});
				})
				.catch((err) => {
					console.error("EXPORT ROUTE ERROR", err);
					this.$vs.loading.close("#optimization-download-content > .con-vs-loading");
					this.$vs.notify({
						color: "danger",
						title: this.$t("Error"),
						text: this.$t("Routing.Map.ExportRoute.Error"),
					});
					console.error(err);
				});
		},
	},
	beforeDestroy() {
		this.clearFields();
	},
};
</script>
